/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'

// Migrated from: lego/lib/Utils.jsx

function indexOfCaseInsensitive(a: string, b: string): number {
  return a.toLowerCase().indexOf(b.toLowerCase())
}

export function highlight_search(input: string, option: string, isOptionPredicted?: boolean): React.ReactElement {
  const num = indexOfCaseInsensitive(option, input)
  const len = input.length

  return (
    <div className={isOptionPredicted ? 'pl5 pt1 mt3 text-predicted' : 'pl5 pt1 mt3'}>
      <span>{option.substr(0, num)}</span>
      {num >= 0 ? (
        <span>
          <b>{option.substr(num, len)}</b>
        </span>
      ) : null}
      <span>{option.substr(num + len)}</span>
    </div>
  )
}
